<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="设备唯一编码" prop="deviceCode">
      <el-input v-model="dataForm.deviceCode" placeholder="设备唯一编码"></el-input>
    </el-form-item>
    <el-form-item label="处理方式 1按通道顺序 2按因子编码" prop="type">
      <el-input v-model="dataForm.type" placeholder="处理方式 1按通道顺序 2按因子编码"></el-input>
    </el-form-item>
    <el-form-item label="数据串" prop="rawData">
      <el-input v-model="dataForm.rawData" placeholder="数据串"></el-input>
    </el-form-item>
    <el-form-item label="上传时间" prop="uploadTime">
      <el-input v-model="dataForm.uploadTime" placeholder="上传时间"></el-input>
    </el-form-item>
    <el-form-item label="状态 1.未处理 3.处理失败" prop="status">
      <el-input v-model="dataForm.status" placeholder="状态 1.未处理 3.处理失败"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="recordTime">
      <el-input v-model="dataForm.recordTime" placeholder="创建时间"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          deviceCode: '',
          type: '',
          rawData: '',
          uploadTime: '',
          status: '',
          recordTime: ''
        },
        dataRule: {
          deviceCode: [
            { required: true, message: '设备唯一编码不能为空', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '处理方式 1按通道顺序 2按因子编码不能为空', trigger: 'blur' }
          ],
          rawData: [
            { required: true, message: '数据串不能为空', trigger: 'blur' }
          ],
          uploadTime: [
            { required: true, message: '上传时间不能为空', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '状态 1.未处理 3.处理失败不能为空', trigger: 'blur' }
          ],
          recordTime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/devicedatatemp/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.dataForm.deviceCode = data.deviceDataTemp.deviceCode
                this.dataForm.type = data.deviceDataTemp.type
                this.dataForm.rawData = data.deviceDataTemp.rawData
                this.dataForm.uploadTime = data.deviceDataTemp.uploadTime
                this.dataForm.status = data.deviceDataTemp.status
                this.dataForm.recordTime = data.deviceDataTemp.recordTime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/devicedatatemp/${!this.dataForm.id ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'id': this.dataForm.id || undefined,
                'deviceCode': this.dataForm.deviceCode,
                'type': this.dataForm.type,
                'rawData': this.dataForm.rawData,
                'uploadTime': this.dataForm.uploadTime,
                'status': this.dataForm.status,
                'recordTime': this.dataForm.recordTime
              })
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1000,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/deviceDataTemp-add-or-update.vue